import { useBookingsSuggestedChanges } from "PFCore/hooks/queries/bookings/suggested_changes/use_bookings_suggested_changes";
import {
  OverbookingsManagementMode,
  SuggestedChangeAction
} from "PFCore/services/bookings_suggested_changes";
import { useFormContext } from "react-hook-form";

import { bookingFormValuesToSuggestedChangesData } from "../../../overbookings_management_modal/overbookings_management_modal.utils";
import { BookingFormValues } from "../../booking_form_provider";

type UseCheckAdjustCurrentMode = {
  overbookingIntersectionsDates: string[];
  canManageOverbookings: boolean;
};

export const useCheckAdjustCurrentMode = ({
  overbookingIntersectionsDates,
  canManageOverbookings
}: UseCheckAdjustCurrentMode) => {
  const { getValues } = useFormContext<BookingFormValues>();

  const bookingsDataAdjustCurrent = bookingFormValuesToSuggestedChangesData(
    getValues(),
    overbookingIntersectionsDates,
    OverbookingsManagementMode.AdjustCurrent
  );

  const { data: currentSuggestedChangesData, isLoading: isCurrentSuggestedDataLoading } =
    useBookingsSuggestedChanges({
      payload: bookingsDataAdjustCurrent,
      options: {
        enabled: canManageOverbookings && !!bookingsDataAdjustCurrent,
        gcTime: 0
      }
    });

  const bookingsDataAdjustOther = bookingFormValuesToSuggestedChangesData(
    getValues(),
    overbookingIntersectionsDates,
    OverbookingsManagementMode.AdjustOther
  );

  const { data: otherSuggestedChangesData, isLoading: isOtherSuggestedDataLoading } =
    useBookingsSuggestedChanges({
      payload: bookingsDataAdjustOther,
      options: {
        enabled: canManageOverbookings && !!bookingsDataAdjustOther,
        gcTime: 0
      }
    });

  const currentBookingCanBeCreated =
    (currentSuggestedChangesData ?? [])?.filter((suggestedChange) => {
      if (suggestedChange.changes.length === 0) {
        return true;
      }
      return (
        suggestedChange.changes.filter(({ action }) => action !== SuggestedChangeAction.Delete).length > 0
      );
    }).length > 0;

  const otherBookingCanBeCreated =
    (otherSuggestedChangesData ?? [])?.filter((suggestedChange) => {
      if (suggestedChange.changes.length === 0) {
        return true;
      }
      return (
        suggestedChange.changes.filter(({ action }) => action !== SuggestedChangeAction.Ignore).length > 0
      );
    }).length > 0;

  return {
    isAdjustCurrentModeDisabled: isCurrentSuggestedDataLoading || !currentBookingCanBeCreated,
    isAdjustOtherModeDisabled: isOtherSuggestedDataLoading || !otherBookingCanBeCreated
  };
};
